/**
 * Show and hide annotation in footer depending on
 * whether they are referenced on the page
 */
window.updateAnnotations = function updateAnnotations() {
    var annotations = ['grundsatz', 'preis'];
    $('a[data-annotation]').each(function () {
        annotations.push($(this).data('annotation'));
    });

    annotations = _.uniq(annotations);
    $('a[data-annotation-target]').each(function () {
        if (!_.includes(annotations, $(this).data('annotation-target'))) {
            $(this).parent('li').hide();
        } else {
            $(this).parent('li').show();
        }
    });
}
